<script setup lang="ts">
import { ref } from 'vue'
import type { VerseAction } from '../../types/verseSelection'

defineProps<{
  visible: boolean
  x: number
  y: number
}>()

const emit = defineEmits<{
  (e: 'action', action: VerseAction): void
}>()

const rootElement = ref<HTMLElement | null>(null)

const handleAction = (action: VerseAction): void => {
  emit('action', action)
}

// 阻止 mousedown 事件傳播到父元素的監聽器
const handleMenuMouseDown = (e: MouseEvent) => {
  e.stopPropagation()
  e.stopImmediatePropagation()
}

defineExpose({
  rootElement,
})
</script>

<template>
  <div
    ref="rootElement"
    class="verse-context-menu"
    :class="{ hidden: !visible }"
    :style="{ top: `${y}px`, left: `${x}px` }"
    @mousedown="handleMenuMouseDown"
  >
    <button
      class="verse-context-menu-item"
      @click.stop="handleAction('bookmark')"
      @mousedown.stop
      @mouseup.stop
    >
      新增書籤
    </button>
    <button
      class="verse-context-menu-item"
      @click.stop="handleAction('note')"
      @mousedown.stop
      @mouseup.stop
    >
      新增筆記
    </button>
  </div>
</template>

<style scoped>
.verse-context-menu {
  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 100;
  min-width: 120px;
  padding: 4px 0;
  pointer-events: auto;
}

.verse-context-menu.hidden {
  display: none;
  pointer-events: none;
}

.verse-context-menu-item {
  padding: 8px 12px;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: #333;
  transition: background-color 0.15s;
}

.verse-context-menu-item:hover {
  background-color: #f3f4f6;
}

.verse-context-menu-item:active {
  background-color: #e5e7eb;
}

.verse-context-menu-item:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}
</style>
